import TagManager from 'react-gtm-module';

// GTM ID from the provided snippet
const GTM_ID = 'GTM-T7WKMCZP';

// Initialize GTM with the tracking ID
export const initializeGTM = (): void => {
  TagManager.initialize({
    gtmId: GTM_ID
  });
};

// Event tracking helper function
export const trackEvent = (event: {
  event: string;
  [key: string]: any;
}): void => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(event);
  }
}; 